import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-performanceMonitorLogger',
  template: ` <p>performance-monitor-logger works!</p> `,
  styles: [],
})
export class PerformanceMonitorComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
